import React from "react"

import { ArrowBack } from "@mui/icons-material"

import { IconButton } from "@cirrus/ui-kit-ts"

import { useNavigationService } from "../providers/NavigationService"

export const GoBack = (props) => {
  const { navigate } = useNavigationService()

  return (<IconButton {...props} sx={{ position: "absolute", left: 0 }} onClick={() => navigate(-1)}>
    <ArrowBack fontSize="small"/>
  </IconButton>)
}